import styled from 'styled-components';

export const WrapperLoader = styled.div`
    text-align: center;
    margin-top: 150px;
`;